export var App;
(function (App) {
    App["VERSION"] = "BETA";
    App["ADMIN_ONE_EMAIL"] = "tim@domainpage.io";
    App["ADMIN_TWO_EMAIL"] = "rigo@domainpage.io";
    App["CUSTOM_DOMAIN_HEADER"] = "x-forwarded-host";
})(App || (App = {}));
